import React from "react";
import ProfileContainer from "../containers/profile/ProfileContainer";
import AdminView from "../views/dashboard/AdminView";
import SupportView from "../views/dashboard/SupportView";
import CustomerView from "../views/dashboard/CustomerView";
import InstallerView from "../views/dashboard/InstallerView";

const renderDashboardPage = (type) => {
  switch (type) {
    case "Admin":
      return <AdminView />;
    case "Support":
      return <SupportView />;
    case "Installer":
      return <InstallerView />;

    case "Customer":
      return <CustomerView />;

    default:
      return null;
  }
};

const DashboardPage = () => {
  return (
    <ProfileContainer>
      {({ content }) =>
        renderDashboardPage(content ? content.groups[0].name : "")
      }
    </ProfileContainer>
  );
};

export default DashboardPage;
